import * as cx from 'classnames';
import { capitalize } from 'lodash-es';
import {
    CAREER,
    CAREER_URL,
    COMMERCIAL,
    COMMERCIAL_URL,
    COOKIE_POLICY_PAGE,
    DATA_PRIVACY,
    FOLLOW_US_ON_FACEBOOK,
    FOLLOW_US_ON_FACEBOOK_URL,
    FOOTER_HELP_LINK,
    PRIVACY_AND_COOKIE_POLICY,
    RULES_BAZAAR,
    RULES_COMMON,
    STROLLER_STROLLEROPEDIA,
} from 'mk/autogenerated/translations/Footer.5700874da4a028bf48998c89be203e5e'
import { ACTIVE_SERVER_ID, BASE_URL } from 'mk/settings';
import {
    about_cookie_policy_url,
    about_help_url,
    about_privacy_url,
    about_rules_bazaar_url,
    about_rules_common_url,
} from 'mk/urls/functions';
import { privacyAndCookiePolicy } from 'mk2/apps/about/urls';
import * as strollersUrls from 'mk2/apps/strollers/urls';
import Link from 'mk2/components/Link';
import * as React from 'react';
import styles from './Footer.mscss';

interface OwnProps {
}

export class Footer extends React.PureComponent<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
    };

    public render() {
        if (ACTIVE_SERVER_ID === 207) {
            const p = BASE_URL.split('.');
            const niceUrl = capitalize(p[p.length - 2] + '.' + p[p.length - 1]);

            return (
                <div className={cx(styles.Footer, styles.Footer_sb)}>
                    <div className={cx(styles.Footer__footer, styles.Footer__footer_sb)}>
                        <div className={styles.Footer__links}>
                            <ul className={cx(styles.Footer__links_row, styles.Footer__links_row_sb)}>
                                <li>
                                    <a href={strollersUrls.strollers}>{niceUrl}</a>
                                </li>
                                <li>
                                    <Link to={privacyAndCookiePolicy}>
                                        {PRIVACY_AND_COOKIE_POLICY}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div
                className={cx(
                    styles.Footer,
                    styles.Footer__hideOnMobile,
                )}
            >
                <div className={styles.Footer__help}>
                      <div className={styles.Footer__links}>
                        <ul className={styles.Footer__links_row}>
                            <li>
                                <i className={cx('fa', 'fa-bandcamp', styles.Footer__lifering)}>
                                    <i className="fa fa-life-ring" />
                                </i>&nbsp;
                                <a href={about_help_url()}>{FOOTER_HELP_LINK}</a>
                            </li>
                            <li>
                                <a href={about_rules_bazaar_url()}>{RULES_BAZAAR}</a>
                            </li>
                            {/* <li>
                                <a href={about_rules_kodex_url()}>{translate(RULES_KODEX)}</a>
                            </li> */}
                            <li>
                                <a href={about_rules_common_url()}>{RULES_COMMON}</a>
                            </li>

                        </ul>
                    </div>
                </div>

                <div className={styles.Footer__footer}>
                    <div className={styles.Footer__links}>
                        <ul className={styles.Footer__links_row}>
                            <li>
                                <a href={COMMERCIAL_URL} target="_blank" rel="noopener">{COMMERCIAL}</a>
                            </li>
                            <li>
                                <a href={CAREER_URL} target="_blank" rel="noopener">{CAREER}</a>
                            </li>
                            <li>
                                <a href={about_cookie_policy_url()}>{COOKIE_POLICY_PAGE}</a>
                            </li>
                            <li>
                                <a href={about_privacy_url()}>{DATA_PRIVACY}</a>
                            </li>
                            <li className={styles.Footer__facebook_title}>
                                <i className={cx('fa', 'fa-facebook-official', styles.Footer__facebook)} />&nbsp;
                                <a href={FOLLOW_US_ON_FACEBOOK_URL} target="_blank" rel="noopener">
                                    {FOLLOW_US_ON_FACEBOOK}
                                </a>
                            </li>
                            <li>
                                <a href={strollersUrls.strollers}>{STROLLER_STROLLEROPEDIA}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
